import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as LegacyThemeProvider } from '@mui/styles';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router';
import { ApolloProvider } from '@apollo/client/react';
import { getClient } from './apollo';
import history from './History';
import { SearchTermProvider } from './context/searchTerm';
import { SnackbarMessageProvider } from './context/SnackbarMessage';
import { EditAppointmentProvider } from './context/EditAppointment';

const client = getClient();

export default ({ children }) => (
    <SnackbarMessageProvider>
        <SearchTermProvider>
            <EditAppointmentProvider>
                <ApolloProvider client={client}>
                    <HistoryRouter history={history}>{children}</HistoryRouter>
                </ApolloProvider>
            </EditAppointmentProvider>
        </SearchTermProvider>
    </SnackbarMessageProvider>
);

export function AppThemeProvider({ theme, children }) {
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <LegacyThemeProvider theme={theme}>
                    <CssBaseline />
                    {children}
                </LegacyThemeProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}

export function MainThemeProvider({ theme, children }) {
    return (
        <ThemeProvider theme={theme}>
            <LegacyThemeProvider theme={theme}>{children}</LegacyThemeProvider>
        </ThemeProvider>
    );
}
